import type { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid var(--ui-border)',
    borderRadius: 8,
    background: 'var(--ui-bg-elevated)',
    minWidth: 0,
  },
  head: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderBottom: '1px solid var(--ui-border)',
  },
  title: { fontSize: '1rem', fontWeight: 600, margin: 0 },
  aside: {
    fontSize: '0.8125rem',
    color: 'var(--ui-text-muted)',
  },
  end: { marginLeft: 'auto' },
}));

/**
 * One card of the Status page: a titled region a test and a screen reader can
 * address by its heading, with an optional note beside the title and an
 * optional link at the end of the head.
 */
export const StatusCard = ({
  id,
  title,
  aside,
  action,
  children,
}: {
  id: string;
  title: string;
  aside?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}) => {
  const classes = useStyles();
  return (
    <section className={classes.card} aria-labelledby={id}>
      <div className={classes.head}>
        <h2 id={id} className={classes.title}>
          {title}
        </h2>
        {aside && <span className={classes.aside}>{aside}</span>}
        {action && (
          <span className={`${classes.aside} ${classes.end}`}>{action}</span>
        )}
      </div>
      {children}
    </section>
  );
};
